import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IReconcileTicketReasons, IReconcileTicketDetail, EntityId, INewComment, ReconcileStatus, TicketStatus } from '@appshared';

@Injectable({
  providedIn: 'root',
})
export class ReconciledDetailApiService {
  protected urlTickets = '/sale-data-svc/api/tickets/';

  constructor(public httpClient: HttpClient) {}

  getTicketDetail(id): Observable<IReconcileTicketDetail> {
    return this.httpClient.get<IReconcileTicketDetail>(this.urlTickets + id);
  }

  getListReason(): Observable<IReconcileTicketReasons> {
    return this.httpClient.get(this.urlTickets + 'reasons');
  }

  updateTicketStatus(ticketId: EntityId, newStatus: TicketStatus): Observable<any> {
    return this.httpClient.patch(`${this.urlTickets}${ticketId}/status`, {
      status: newStatus,
    });
  }

  confirmReason(ticketId: EntityId, confirmFrmValue: any): Observable<any> {
    return this.httpClient.patch(`${this.urlTickets}${ticketId}/reconcile-reason`, {
      reason: confirmFrmValue.selectReason,
      description: confirmFrmValue.descriptionTxt,
    });
  }

  newComment(ticketId: EntityId, newComment: INewComment): Observable<any> {
    let formData = new FormData();
    formData.append('detail', newComment.detail);
    formData.append('parentCommentId', newComment.parentCommentId);
    newComment.attachments.forEach((file: File, key) => {
      formData.append('attachmentsDto[]', file, file.name);
    });

    return this.httpClient.post(`${this.urlTickets}${ticketId}/comments`, formData);
  }
}
